// 存储localStorage
export const setStore = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}

// 获取localStorage
export const getStore = (name) => {
  if (!name) return
  return window.localStorage.getItem(name)
}

// 删除localStorage
export const removeStore = (name) => {
  if (!name) return
  window.localStorage.removeItem(name)
}

export const addTraceStore = (name, traceItem) => {
  const target = window.localStorage.getItem(name)
  if (target) {
    const tempArr = JSON.parse(target)
    if (Array.isArray(tempArr)) {
      tempArr.push(traceItem)
      window.localStorage.setItem(name, JSON.stringify(tempArr))
    }
  }
  // 未存储
  else {
    const traceArr = [traceItem]
    window.localStorage.setItem(name, JSON.stringify(traceArr))
  }
}

export const getTraceStore = (name) => {
  const target = window.localStorage.getItem(name)
  if (target) {
    const tempArr = JSON.parse(target)
    if (Array.isArray(tempArr)) {
      return tempArr
    }
    return []
  }
  // 未存储
  else {
    return []
  }
}
